import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{class:_vm.$style.workContainer},[_c('img',{class:['mx-3', _vm.$style.workImage],attrs:{"src":_vm.getImgSrc(_vm.p_workData.img)},on:{"load":function($event){return _vm.$emit('loadImgWork')}}}),_c(VFlex,{attrs:{"column":""}},[_c('span',{staticClass:"display-1"},[_vm._v(" "+_vm._s(_vm.$langs.translate(_vm.p_workData.name))+" ")]),_c('div',[_c('p',{staticClass:"body-1"},[_vm._v(" "+_vm._s(_vm.$langs.translate(_vm.p_workData.text))+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }